import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02491570"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "call-ended-message ion-text-center font-style-dark"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"video-controls\" data-v-02491570><div class=\"control-button-container\" data-v-02491570><div class=\"control-button disabled\" data-v-02491570><i class=\"icon-tele-camera-flip\" data-v-02491570></i></div></div><div class=\"control-button-container\" data-v-02491570><div class=\"control-button disabled\" data-v-02491570><i class=\"icon-tele-call\" data-v-02491570></i></div></div><div class=\"control-button-container\" data-v-02491570><div class=\"control-button disabled\" data-v-02491570><i class=\"icon-tele-volume-up\" data-v-02491570></i></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventStateSpinner = _resolveComponent("EventStateSpinner")!
  const _component_RouteButton = _resolveComponent("RouteButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: "waiting-room-overlay",
    style: _normalizeStyle(_ctx.getBackgroundImage)
  }, [
    _createVNode(_component_EventStateSpinner, {
      showFailureState: _ctx.showFailure,
      isLoading: _ctx.getIsLoading,
      loadingIcon: "icon-tele-doc",
      loadingTitle: this.$mhat('PublicWaitingRoomOverlay.LoadingTitle'),
      loadingMessage: _ctx.getLoadingMessages,
      successIcon: "icon-tele-doc",
      successTitle: this.$mhat('PublicWaitingRoomOverlay.AppointmentEndedTitle'),
      failureTitle: _ctx.failureOrDefault.title,
      failureMessage: _ctx.failureOrDefault.message,
      textColorLight: ""
    }, null, 8, ["showFailureState", "isLoading", "loadingTitle", "loadingMessage", "successTitle", "failureTitle", "failureMessage"]),
    (!_ctx.isLoading && !_ctx.showFailureState)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", null, _toDisplayString(this.$mhat("PublicWaitingRoomOverlay.AppointmentEndedMessage")), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_RouteButton, {
      pattern: _ctx.ButtonColorPattern.TRANSPARENT,
      color: _ctx.ButtonColor.PRIMARY,
      route: _ctx.Route.Home
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(this.$mhat("PublicWaitingRoomOverlay.HomeButtonText")), 1)
      ]),
      _: 1
    }, 8, ["pattern", "color", "route"]),
    _hoisted_2
  ], 4))
}